module.exports = __webpack_public_path__ + "img/img_aboutus_02.6305d628.png";